var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DndProvider } from "react-dnd";
export var UiProvider = function (_a) {
    var children = _a.children, backend = _a.backend;
    return _jsx(DndProvider, __assign({ backend: backend }, { children: children }), void 0);
};
